// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e7f709e8","453":"f1c44582","732":"80cccd2f","977":"732381b8"}[chunkId] + ".chunk.js";
};